import * as types from "./types";

const clearStore = () => ({
  type: types.CLEAR_STORE
});

/* Fetch user */
const fetchingUser = id => ({
  type: types.FETCHING_USER,
  payload: id
});

const fetchingUserSuccess = data => ({
  type: types.FETCHING_USER_SUCCESS,
  payload: data
});

const fetchingUserError = error => ({
  type: types.FETCHING_USER_ERROR,
  payload: error
});

/* Fetch user */

export { fetchingUser, fetchingUserSuccess, fetchingUserError, clearStore };
